import React, {Component} from 'react'
import {inject, observer} from 'mobx-react'
import {Modal, Button, Input, Alert, Icon} from 'antd'

import style from './disable.sass'

@inject('store') @observer
class Disable extends Component {
  state = {
    password: ''
  }
  handleChange = (e) => {
    const {value} = e.target
    this.setState({password: value})
  }
  disable = () => {
    this.props.store.user.disableAccount(this.state.password)
  }
  render() {
    return(
      <Modal
        title='Are you sure you want to disable your account?'
        visible={this.props.visible}
        onCancel={this.props.close}
        footer={[
          <Button key='cancel' onClick={this.props.close}>Cancel</Button>,
          <Button key='disable' type='danger' onClick={this.disable}>Disable Account</Button>
        ]}
        destroyOnClose
      >
        <Input
          type='password'
          onChange={this.handleChange}
          value={this.state.password}
          placeholder='Password'
          size='large'
          styleName='password'
        />
        <Alert
          message='This action is permanent and cannot be reversed!'
          type='error'
          icon={<Icon type='exclamation-circle'/>}
          showIcon
        />
      </Modal>
    )
  }
}

export default Disable
